import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('item-sub-category/index', {params});
    },
    getSubCategory(params) {
        return Service().get('item-sub-category/get-item-sub-category', {params});
    },
    show(id) {
        return Service().get('item-sub-category/show/'+id);
    },
    create(params) {
        return Service().post('item-sub-category/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('item-sub-category/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('item-sub-category/delete/'+id);
    },
}